<template>
  <div>
    <el-button type="text" @click="gotoFull">查看完整人才流动</el-button>
    <div id="poof-talentflow-sankey" v-loading="sankeyLoading" style="height:500px"></div>
    <!-- 点击流入流出统计详细弹窗 -->
      <InoutDetail ref="InoutDetail" style="left: calc(50vw - 200px);top: 230px;"></InoutDetail>
  </div>
</template>
<script>
import InoutDetail from '../../../../company/src/dialog/inoutDetailDialog'

const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/sankey')

let sankeyId2Company = {}
export default {
  components: { InoutDetail },
  props: {
    company: { type: Object, default: () => {} },
  },
  data() {
    return {
      sankeyLoading: false,
    }
  },
  methods: {
    async initData() {
      this.sankeyLoading = false,
      this.open()
    },
    async open() {
      this.sankeyLoading = true
      const now = new Date()
      const m = now.getMonth() + 1
      const y = now.getFullYear()
      const date = { $gte: `${y - 1}-${m < 10 ? `0${m}` : m}-01`, $lte: `${y}-${m < 10 ? `0${m}` : m}-31` }
      const query = {时间段: date, 公司: this.company.简称}
      let res
      if (this.company.行业 === '私募股权（PEVC）') {
        delete query.时间段
        res = await app.service('statistics').getPevcFlowGraphy(query)
      } else {
        res = await app.service('statistics').getFlowGraphy(query)
      }
      if (res.status === 'success') {
        this.loadSankey(res.data)
      } else this.$message.error(res.msg)
      this.sankeyLoading = false
    },
    async loadSankey(params) {
      try {
        const processData = await this.processData(params)
        const option = {
          title: {
            text: '人才流动图',
            top: 'bottom',
            left: 'center',
            textStyle: {
              color: '#ccc',
            },
          },
          tooltip: {},
          series: [
            {
              type: 'sankey',
              left: 50.0,
              top: 20.0,
              right: 200.0,
              bottom: 25.0,
              data: processData.data ? processData.data.slice(0, 20) : [],
              links: processData.links || [],
              tooltip: {
                formatter: function(param) {
                  const value = param.data
                  if (value.source || value.target) {
                    return `${sankeyId2Company[value.source]}-->${sankeyId2Company[value.target]}:${value.value}`
                  } else return `${value.name}：${value.count}`
                },
              },
              itemStyle: {
                normal: {
                  borderColor: '#fff',
                  borderWidth: 1,
                  shadowBlur: 10,
                  shadowColor: 'rgba(0, 0, 0, 0.3)',
                },
              },
              label: {
                position: 'right',
                formatter: '{b}',
              },
              lineStyle: {
                color: 'source',
                curveness: 0.3,
              },
            },
          ],
        }
        this.$nextTick(_ => {
          const myChart = echarts.init(document.getElementById('poof-talentflow-sankey'))
          myChart.setOption(option, true)
          myChart.on('click', (event) => {
            this.sankeyShowDetail(event)
          })
        })
      } catch (error) {
        this.$message.error(error.message)
        console.log(error.stack)
      }
    },
    sankeyShowDetail(item){
      const { data } = item
      const { data:nodes, links, transfer, companyNode } = this.sankeyObj
      if(data.source){
        const outNode = nodes.find(v=>`${v.id}`===`${data.source}`)
        const inNode = nodes.find(v=>`${v.id}`===`${data.target}`)
        const arr = transfer.filter(v=>v.来源公司===outNode.name&&v.目标公司===inNode.name)
        this.showInOutDetail(arr)
      }else{
        const node = data
        const outNode = node.category==='in' ? companyNode : node
        const inNode = node.category==='in' ? node : companyNode
        const arr = transfer.filter(v=>v.来源公司===outNode.name&&v.目标公司===inNode.name)
        this.showInOutDetail(arr)
      }
    },
    showInOutDetail(radishes, row) {
      if (!Array.isArray(radishes) || radishes.length === 0) return
      this.$refs.InoutDetail.open(radishes,this.company.行业 === '私募股权（PEVC）')
    },
    async processData({ nodes, linkList, transfer }) {
      const result = { data: [], links: [] }
      if (nodes.length === 0) {
        this.$message.success('没有变动数据')
        this.showSankey = false
        return result
      } else {
        this.showSankey = true
      }

      const copyNodes = window._.cloneDeep(nodes)
      let copyLinklist = window._.cloneDeep(linkList)

      const mainNode = copyNodes.find(v=>v.name===this.company.公司名称||v.name===this.company.简称)
      let companyNode = mainNode

      if(!companyNode){
        const countNode = {}
        copyLinklist.forEach(v=>{
          if(!countNode[v.source])countNode[v.source]=0
          countNode[v.source]+=1
          if(!countNode[v.target])countNode[v.target]=0
          countNode[v.target]+=1
        })
        let max = {id:null,num:0}
        for(const id in countNode){
          if(countNode[id]>max.num) max = {id:id,num:countNode[id]}
        }
        companyNode = copyNodes.find(v=>`${v.id}`===`${max.id}`)
      }

      const companyIn = copyNodes.find(v=>v.name===companyNode.name&&v.category==='in')
      const companyOut = copyNodes.find(v=>v.name===companyNode.name&&v.category==='out')
      const companyNodeIds = [`${companyIn && companyIn.id}`,`${companyOut && companyOut.id}`].filter(v=>v!=="undefined")

      copyLinklist = copyLinklist.filter(v=>companyNodeIds.includes(v.source)||companyNodeIds.includes(v.target))

      const nodeMap = {}
      copyNodes.forEach(v => {
        nodeMap[v.id] = v.name
      })
      const linkCompanies = []
      const categories = []
      copyLinklist.forEach(v => {
        if (!linkCompanies.includes(nodeMap[v.source])) linkCompanies.push(nodeMap[v.source])
        if (!linkCompanies.includes(nodeMap[v.target])) linkCompanies.push(nodeMap[v.target])
        if (`${v.source}` === `${(companyOut && companyOut.id)}`&&companyIn) v.source = `${companyIn.id}`
      })
      copyNodes.forEach(v=>{
        if(linkCompanies.includes(v.name)&&((companyIn&&v!==companyOut)||!companyIn)) {
          v.id = `${v.id}`
          delete v.公司介绍
          categories.push(v)
        }

      })

      categories.sort((a,b)=>b.symbolSize-a.symbolSize)

      result.data = categories
      result.links = copyLinklist.filter(v=>v.source!==v.target)
      result.transfer = transfer
      result.companyNode = companyNode

      this.sankeyObj = result

      sankeyId2Company = nodeMap

      return result
    },
    gotoFull() {
      window.open(`${window.frontend}/#/newTalentFlow?defaultType=${this.company.行业 === '私募股权（PEVC）'?'PEVC':this.company.行业}&defaultCompany=${this.company.简称}`, '_blank')
    }
  }
}
</script>
